import {
	getController,
	apiService as Service,
	type HpRequestOptional,
} from '@/services/service'

const url = 'meter'

export type GetLevelInput = {
	id: number
	targetId: number
	data?: HpRequestOptional
}

export type GetLevelBinaryInput = {
	id: number
	level_id: number
	document_id: number
	responseType: Api.ResponseType
}

export const meterService = {
	...getController<Api.Meter, Api.MeterPostInput, Api.MeterPostInput>(url),
	getLevel: ({ id, targetId, data }: GetLevelInput) =>
		Service.get({
			url: `${url}/${id}/level/${targetId}`,
			...data,
		}),
	getLevelBinary: ({
		id,
		level_id,
		document_id,
		responseType,
	}: GetLevelBinaryInput) =>
		Service.get({
			url: `${url}/${id}/level/${level_id}/documents/${document_id}/binary`,
			responseType: responseType,
		}),
}

export default meterService
